import { render } from "./areaEvaYearTimeEchart.vue?vue&type=template&id=4b32498f&scoped=true"
import script from "./areaEvaYearTimeEchart.vue?vue&type=script&lang=js"
export * from "./areaEvaYearTimeEchart.vue?vue&type=script&lang=js"

import "./areaEvaYearTimeEchart.vue?vue&type=style&index=0&id=4b32498f&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b32498f"]])

export default __exports__